"use client";

import { lazy, Suspense } from "react";
import { useTenant } from "@/components/TenantProvider";

const IpungLoginForm = lazy(() => import("@/tenants/ipung/auth/LoginPage"));
const AdaraLoginForm = lazy(() => import("@/tenants/adara/auth/LoginPage"));
const Smkn3LoginForm = lazy(() => import("@/tenants/smkn3/auth/LoginPage"));

function LoginForm() {
  const { tenant } = useTenant();
  if (tenant.businessType === "personal") return <IpungLoginForm />;
  if (tenant.businessType === "education") return <Smkn3LoginForm />;
  return <AdaraLoginForm />;
}

export default function LoginPage() {
  return (
    <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-[#0a0a1a]"><div className="w-8 h-8 border-2 border-[#6C5CE7] border-t-transparent rounded-full animate-spin"/></div>}>
      <LoginForm />
    </Suspense>
  );
}
